export function formatExportStudentId(raw) {
  if (raw === null || raw === undefined) {
    return '';
  }
  const s = String(raw).trim();
  return /^\d{6}$/.test(s) ? s : '';
}
